import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * POST /api/v2/process/:id/draft/events/:eventId/attach — create or adopt
 * an event input on the target node and wire it to this event. Mirrors the
 * step successor connect endpoint's shape for event edges. The target may
 * be a draft step or a draft assignment (shared `stableStepId` space); the
 * response envelope carries the updated target under its `nodeKind`.
 */ export const AttachDraftEventRequestSchema = z.object({
    targetStepId: ObjectIdSchema
});

//# sourceMappingURL=attach-draft-event.schema.js.map